import React, { Fragment } from 'react'
import '../../App.css';

const Footer = () => {
return (
    <Fragment>
     <footer className="py-1">
      <p className="text-center mt-1">
        Shop Tech - 2022-23, All Rights Reserved to <b style={{color:'red'}}>Sahil kumar</b>
      </p>
    </footer>      
    </Fragment>
  )
}

export default Footer